import moment from 'moment'

export function getDay () {
  var today = moment().dayOfYear()
  var christmas = moment(moment().year() + '-12-25').dayOfYear()
  var daysUntil = christmas - today
  var day
  if (daysUntil < 0) {
    day = 28 - daysUntil
    console.log(Math.abs(daysUntil))
  } else {
    var daysUntilMod = daysUntil % 28
    day = 28 - daysUntilMod
  }
  console.log(day)
  return day
}
